import Vue from 'vue';
import Router from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'; // https://www.npmjs.com/package/vue-router-prefetch

import { commonLanguageLogic, updateLanguageMessages } from '@motionelements/core/src/services/language.service.js';
import i18n from '@/lang/i18n.js';
import { preLoadedLanguages } from '@/lang';
import routes from './routes';


Vue.use(Router);
Vue.use(RouterPrefetch); // Prefetch links when they are visible in viewport.

const router = new Router({
  mode: 'history',
  routes: routes,
  // scrolls to top on route to next page
  // https://router.vuejs.org/guide/advanced/scroll-behavior.html#async-scrolling
  // scrollBehavior(to, from, savedPosition) {
  scrollBehavior(to) {
    console.log('scrollBehavior', to);

    // https://forum.vuejs.org/t/disable-scroll-behavior-for-a-specific-route/45093/3
    if (to.matched.some(m => m.meta.disableScrollToTop)) {
      console.log('scrollBehavior pass');
      return false;
    }

    const position = { x: 0, y: 0 };
    console.log('scroll top');
    // eslint-disable-next-line
    if (to.hash) {
      // allow scroll to '#fragment'
      return new Promise((resolve) => {
      // return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
            selector: to.hash,
          });
        }, 1000);
      });
    }
    // return new Promise((resolve, reject) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(position);
      }, 0);
    });
  },
});

router.beforeEach((to, from, next) => {
  commonLanguageLogic({ to, from }, preLoadedLanguages, i18n)
    .then(languageCode => {
      if (languageCode) { // lazy load language
        import(`@/lang/json/${languageCode}.json`)
          .then(messages => {
            updateLanguageMessages({ to, from, next }, languageCode, messages, preLoadedLanguages, i18n);
            next();
          });
      } else {
        next();
      }
    });
});

export default router;
